import { UseCheckboxGroupReturn } from "@chakra-ui/react";
import { IFilterTag } from "src/api/server/extended-search";
import { IChangeFilterTag } from "src/components/pages/search/components/types";
import { useSearchStore } from "src/components/pages/search/store/search-store";
import { KEY_ENTER, KEY_SPACE } from "src/consts/keyboard";
import { EnumTagColor } from "src/types/common-enum";
import { FilterTagCheckbox } from "./filter-tag-checkbox/filter-tag-checkbox";

export interface ICheckboxList {
    filterTags: IFilterTag[];
    color: EnumTagColor;
    getCheckboxProps: UseCheckboxGroupReturn["getCheckboxProps"];
    onChange: (changeFilterTag: IChangeFilterTag) => void;
}

export const CheckboxList = ({ filterTags, color, getCheckboxProps, onChange }: ICheckboxList) => {
    const { tags: selectedTags } = useSearchStore();

    const isTagChecked = (tag: IFilterTag) => selectedTags.some(selectedTag => selectedTag.value === tag.urlIdentifier);

    const handleKeyDown = (event: React.KeyboardEvent<HTMLLabelElement>, tag: IFilterTag) => {
        if (event.key === KEY_SPACE || event.key === KEY_ENTER) {
            event.preventDefault();
            onChange({
                isChecked: !isTagChecked(tag),
                value: tag.urlIdentifier as string,
                isPopular: tag.isPopular,
            });
        }
    };

    return (
        <>
            {filterTags.map((tag: IFilterTag) => (
                <FilterTagCheckbox
                    key={tag.urlIdentifier}
                    color={color}
                    label={tag.label}
                    {...getCheckboxProps({ value: tag.urlIdentifier })}
                    isChecked={isTagChecked(tag)}
                    onChange={event =>
                        onChange({
                            isChecked: event.target.checked,
                            value: tag.urlIdentifier as string,
                            isPopular: tag.isPopular,
                        })
                    }
                    onKeyDown={event => handleKeyDown(event, tag)}
                />
            ))}
        </>
    );
};
